import { LCDocumentEditorUtils } from './LCDocumentEditorUtils';
import { ILectioPlugin } from './Types';

export class PluginOpenLink implements ILectioPlugin {
	public Init(): void {

		//https://github.com/mlewand/ckeditor-plugin-openlink
		CKEDITOR.plugins.add('openlink', {
			lang: 'da', // %REMOVE_LINE_CORE%
			//icons: 'openLink', // %REMOVE_LINE_CORE%
			hidpi: true, // %REMOVE_LINE_CORE%
			//requires: 'link,contextmenu',

			init: editor => {
				// Register openLink command.
				editor.addCommand('openLink', {
					exec: editor => {
						const anchor = getActiveLink(editor);
						let href = '';

						if (anchor) {
							href = (anchor as any).getAttribute('href') || '';
						}

						if (href) {
							window.open(href);
						}

						return true;
					}
				});

				// Register menu items.
				if (editor.addMenuItems) {
					editor.addMenuItems({
						openLink: {
							label: editor.lang.openlink.menu,
							command: 'openLink',
							group: 'link',
							order: -1,
							icon: ''
						}
					});
				}

				//If the "contextmenu" plugin is loaded, register the listeners.
				editor.contextMenu.addListener((element, selection) => {
					if (!element) {
						return null;
					}

					const anchor = getActiveLink(editor);

					if (anchor && (anchor as any).getAttribute('href')) {
						return { openLink: CKEDITOR.TRISTATE_OFF };
					}

					return {};
				});

				// A quick workaround for issue #11842.
				editor.on('contentDom', evt => {
					const editable = editor.editable();
					if (editable == null)
						return;

					// We want to be able to open links also in read-only mode. This
					// listener will open link in new tab.
					editable.attachListener(editable, 'click', evt => {
						// This feature should be available in:
						// * wysywigmode in read-only
						// * wysywigmode when ctrl key is down
						const target = evt.data.getTarget(),
							clickedAnchor = (new CKEDITOR.dom.elementPath(target, editor.editable() as CKEDITOR.editable)).contains('a'),
							href = clickedAnchor && clickedAnchor.getAttribute('href'),
							config = editor.config,
							modifierCode = typeof config.openlink_modifier !== 'undefined' ? config.openlink_modifier : CKEDITOR.CTRL,
							// Note that modifier might be 0/false, then it should open the link no matter what.
							// tslint:disable-next-line:no-bitwise
							modifierPressed = !modifierCode || (evt.data.getKeystroke() & modifierCode) !== 0;

						if (editor.readOnly && !config.openlink_enableReadOnly) {
							return;
						}

						if (href && modifierPressed) {
							window.open(href, '_blank');
						}
					});
				});
			}
		});

		// Returns the element of active (currently focused) link.
		// It has also support for linked image2 instance.
		// @return {CKEDITOR.dom.element}
		function getActiveLink(editor: CKEDITOR.editor) {
			let anchor = CKEDITOR.plugins.link.getSelectedLink(editor);
				// We need to do some special checking against widgets availability.
			const activeWidget = editor.widgets && editor.widgets.focused;

			// If default way of getting links didn't return anything useful
			if (!anchor && activeWidget && activeWidget.name === 'image' && activeWidget.parts.link) {
				// Since CKEditor 4.4.0 image widgets may be linked.
				anchor = activeWidget.parts.link;
			}

			return anchor;
		}
	}
}
